import {Space} from "antd";
import {LiveEventAttendeesTypeFormField} from "./attendees-type";
import {LiveEventAttendeesFormField} from "./attendees-form-field";

export function LiveEventAttendeesFormFields() {
  return (
    <Space size={16} direction="vertical" style={{display: "flex"}}>
      <LiveEventAttendeesTypeFormField />
      <LiveEventAttendeesFormField />
    </Space>
  );
}
